import { Alert, Button } from '@pms-digital/design-system';

interface LectureControleImpossibleProps {
  /** Reads the control again; without it the message is shown alone. */
  onReessayer?: (() => void) | undefined;
  /** A new attempt is under way: the button waits. */
  enCours?: boolean | undefined;
}

/**
 * The control could not be read (#34: network, timeout, service error): not the same thing as a
 * noyau Tahiti has no control for (`MessageIndisponible`, a sober note with nothing to do). It
 * says so and offers "réessayer". the `Alert` of the design system (danger tone, `role="alert"`) announces it when it appears, like
 * the other failures of the application; the button is a real `<button>` with the global focus ring.
 */
export function LectureControleImpossible({
  onReessayer,
  enCours,
}: LectureControleImpossibleProps) {
  return (
    <div className="mt-3">
      <Alert
        tone="danger"
        action={
          onReessayer === undefined ? undefined : (
            <Button
              type="button"
              variant="primary"
              disabled={enCours === true}
              onClick={onReessayer}
            >
              réessayer
            </Button>
          )
        }
      >
        Le contrôle qualité de cette traduction n'a pas pu être lu.
      </Alert>
    </div>
  );
}
